import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useMessageBarTracked } from "presentation/store/MessageBarProvider";
import { FC, useCallback } from "react";
import { Notification } from "./Notification";
import { getDefaultBuConfig } from "domain/repository/apiUtil";


type Props = {
    children?: React.ReactNode
};

export const MessageBarChildWrapper: FC<Props> = ({
    children
}) => {
    const [messageBarState] = useMessageBarTracked();
    const messageBarVM = useMessageBarVM();
    const messageBarTimer: number = Number(getDefaultBuConfig("REACT_APP_MESSAGE_BAR_TIMER")) || 5;

    const onCloseMsgBar = useCallback(() => {
        messageBarVM.showClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messageBarVM]);
    return (
        <>
            {children}
            <div style={{ zIndex: "99" }}>
                <Notification
                    notificationMessage={messageBarState.message}
                    isNotificationError={messageBarState.isNotificationError}
                    isWarning={messageBarState.isWarning}
                    onClearNotification={onCloseMsgBar}
                    isActiveScreen={messageBarState.isActiveScreen}
                    isTime={messageBarTimer}
                />
            </div>
        </>
    )
}